import React from 'react'
import { useTranslation } from 'react-i18next'

import Button from '@mui/material/Button'
import ButtonGroup from '@mui/material/ButtonGroup'
import { useTheme } from '@mui/material/styles'

export interface CategoryButtonGroupProps<T> {
  options: { label: string; value: T }[]
  selected: T
  onChange: (value: T) => void
  size?: 'small' | 'medium' | 'large'
}

export function CategoryButtonGroup<T>({
  options,
  selected,
  onChange,
  size = 'medium',
}: CategoryButtonGroupProps<T>) {
  const theme = useTheme()

  return (
    <ButtonGroup
      variant="outlined"
      aria-label="Category Options"
      sx={{
        borderColor: theme.palette.divider,
        background: theme.palette.background.paper,
        '& .MuiButtonGroup-grouped': {
          borderColor: theme.palette.divider,
        },
      }}
    >
      {options.map((el) => {
        const isSelected = el.value === selected

        return (
          <Button
            key={String(el.value)}
            onClick={() => onChange(el.value)}
            size={size}
            sx={{
              whiteSpace: 'nowrap',
              minWidth: 'fit-content',
              padding: `${theme.spacing(0.5)} ${theme.spacing(2)}`,
              fontSize: 16,
              fontWeight: 400,
              color: isSelected ? 'primary.main' : 'common.black',
              borderStyle: 'solid',
              borderRightWidth: '1px',
              '&.MuiButtonGroup-grouped': {
                borderColor: isSelected ? 'primary.main' : theme.palette.divider,
              },
              '&:hover': {
                background: theme.palette.action.hover,
                color: isSelected ? 'primary.main' : 'common.black',
                '&.MuiButtonGroup-grouped': {
                  borderColor: isSelected ? 'primary.main' : theme.palette.divider,
                },
              },
            }}
          >
            {el.label}
          </Button>
        )
      })}
    </ButtonGroup>
  )
}
